import { createContext, useContext } from 'react'

type DrawerContextType = {
  id: string
  onClose: () => void
}

export const DrawerContext = createContext<DrawerContextType | undefined>(
  undefined
)

export const useDrawerContext = () => useContext(DrawerContext)
